"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _immutable = require("immutable");

var _propTypes = _interopRequireDefault(require("prop-types"));

var _createReactClass = _interopRequireDefault(require("create-react-class"));

var _react = _interopRequireDefault(require("react"));

var _reactRedux = require("react-redux");

var _reactAddonsCssTransitionGroup = _interopRequireDefault(require("react-addons-css-transition-group"));

var FormActions = _interopRequireWildcard(require("MeetingsLib/redux/actions/FormActions"));

var _EmailForm = _interopRequireDefault(require("MeetingsLib/components/sections/EmailForm"));

var _DatePickerSection = _interopRequireDefault(require("MeetingsLib/components/sections/DatePickerSection"));

var _TimeOptionsSection = _interopRequireDefault(require("MeetingsLib/components/sections/TimeOptionsSection"));

var _PropertyForm = _interopRequireDefault(require("MeetingsLib/components/sections/PropertyForm"));

var _LegalConsentForm = _interopRequireDefault(require("MeetingsLib/components/sections/LegalConsentForm"));

var _Branding = _interopRequireDefault(require("MeetingsBase/models/Branding"));

var _UserProfile = _interopRequireDefault(require("MeetingsBase/models/UserProfile"));

var _BookingLifecycle = _interopRequireDefault(require("MeetingsLib/models/BookingLifecycle"));

var _FormState = _interopRequireDefault(require("MeetingsLib/models/FormState"));

var CompactBookingPage = (0, _createReactClass.default)({
  propTypes: {
    avatar: _propTypes.default.string,
    branding: _propTypes.default.instanceOf(_Branding.default).isRequired,
    canSubmitInitialPropertyForm: _propTypes.default.bool,
    embedded: _propTypes.default.bool.isRequired,
    headline: _propTypes.default.string,
    isFetchingPublicAvailability: _propTypes.default.bool.isRequired,
    profile: _propTypes.default.instanceOf(_UserProfile.default),
    submittingMeeting: _propTypes.default.bool,
    shouldShowEmailForm: _propTypes.default.bool.isRequired,
    bookingLifecycle: _propTypes.default.instanceOf(_BookingLifecycle.default).isRequired,
    formState: _propTypes.default.instanceOf(_FormState.default),
    legalConsentEnabled: _propTypes.default.bool.isRequired,
    legalConsentResponses: _propTypes.default.instanceOf(_immutable.List),
    resetEventDate: _propTypes.default.func.isRequired,
    resetEventDateTime: _propTypes.default.func.isRequired,
    resetFormState: _propTypes.default.func.isRequired,
    markShowedEmailForm: _propTypes.default.func.isRequired,
    DatePickerMarker: _propTypes.default.func.isRequired,
    TimePickerMarker: _propTypes.default.func.isRequired,
    EmailFormMarker: _propTypes.default.func.isRequired
  },
  getLegalBackFunction: function getLegalBackFunction() {
    var _this$props = this.props,
        canSubmitInitialPropertyForm = _this$props.canSubmitInitialPropertyForm,
        resetEventDateTime = _this$props.resetEventDateTime,
        resetFormState = _this$props.resetFormState;
    return canSubmitInitialPropertyForm ? resetEventDateTime : resetFormState;
  },
  renderEmailFormStep: function renderEmailFormStep() {
    var _this$props2 = this.props,
        branding = _this$props2.branding,
        markShowedEmailForm = _this$props2.markShowedEmailForm,
        EmailFormMarker = _this$props2.EmailFormMarker;
    return _react.default.createElement(_EmailForm.default, {
      branding: branding,
      compact: true,
      markShowedEmailForm: markShowedEmailForm,
      EmailFormMarker: EmailFormMarker
    });
  },
  renderDatePickerStep: function renderDatePickerStep() {
    var _this$props3 = this.props,
        avatar = _this$props3.avatar,
        branding = _this$props3.branding,
        embedded = _this$props3.embedded,
        headline = _this$props3.headline,
        profile = _this$props3.profile,
        DatePickerMarker = _this$props3.DatePickerMarker,
        TimePickerMarker = _this$props3.TimePickerMarker;
    return _react.default.createElement(_DatePickerSection.default, {
      key: "compact-date",
      avatar: avatar,
      branding: branding,
      compact: true,
      embedded: embedded,
      headline: headline,
      profile: profile,
      DatePickerMarker: DatePickerMarker,
      TimePickerMarker: TimePickerMarker
    });
  },
  renderTimeOptionsStep: function renderTimeOptionsStep() {
    var _this$props4 = this.props,
        branding = _this$props4.branding,
        profile = _this$props4.profile,
        isFetchingPublicAvailability = _this$props4.isFetchingPublicAvailability,
        resetEventDate = _this$props4.resetEventDate,
        TimePickerMarker = _this$props4.TimePickerMarker;
    return _react.default.createElement(_TimeOptionsSection.default, {
      key: "compact-time",
      branding: branding,
      compact: true,
      goToPreviousStep: resetEventDate,
      isFetchingPublicAvailability: isFetchingPublicAvailability,
      profile: profile,
      TimePickerMarker: TimePickerMarker
    });
  },
  renderPropertyFormStep: function renderPropertyFormStep() {
    var _this$props5 = this.props,
        branding = _this$props5.branding,
        canSubmitInitialPropertyForm = _this$props5.canSubmitInitialPropertyForm,
        submittingMeeting = _this$props5.submittingMeeting,
        bookingLifecycle = _this$props5.bookingLifecycle,
        resetEventDateTime = _this$props5.resetEventDateTime;
    return _react.default.createElement(_PropertyForm.default, {
      key: "compact-property",
      branding: branding,
      canSubmitInitialPropertyForm: canSubmitInitialPropertyForm,
      goToPreviousStep: resetEventDateTime,
      compact: true,
      submittingMeeting: submittingMeeting,
      dateTime: bookingLifecycle.event.dateTime
    });
  },
  renderLegalConsentFormStep: function renderLegalConsentFormStep() {
    var _this$props6 = this.props,
        branding = _this$props6.branding,
        submittingMeeting = _this$props6.submittingMeeting;
    return _react.default.createElement(_LegalConsentForm.default, {
      key: "compact-legalConsent",
      branding: branding,
      goToPreviousStep: this.getLegalBackFunction(),
      submittingMeeting: submittingMeeting
    });
  },
  renderLastStep: function renderLastStep() {
    var legalConsentEnabled = this.props.legalConsentEnabled;

    if (legalConsentEnabled) {
      return this.renderLegalConsentFormStep();
    }

    return this.renderPropertyFormStep();
  },
  renderCurrentStep: function renderCurrentStep() {
    var _this$props7 = this.props,
        shouldShowEmailForm = _this$props7.shouldShowEmailForm,
        bookingLifecycle = _this$props7.bookingLifecycle,
        formState = _this$props7.formState,
        legalConsentEnabled = _this$props7.legalConsentEnabled,
        legalConsentResponses = _this$props7.legalConsentResponses,
        submittingMeeting = _this$props7.submittingMeeting;

    if (shouldShowEmailForm) {
      return this.renderEmailFormStep();
    }

    if (!bookingLifecycle.event.dateString) {
      return this.renderDatePickerStep();
    }

    if (!bookingLifecycle.event.dateTime) {
      return this.renderTimeOptionsStep();
    }

    if (!formState) {
      return this.renderPropertyFormStep();
    }

    if (legalConsentEnabled && !legalConsentResponses) {
      return this.renderLegalConsentFormStep();
    }

    if (submittingMeeting) {
      return this.renderLastStep();
    }

    return null;
  },
  render: function render() {
    return _react.default.createElement("div", {
      className: "compact-container m-x-auto"
    }, _react.default.createElement(_reactAddonsCssTransitionGroup.default, {
      transitionName: "step-animation",
      transitionEnterTimeout: 500,
      transitionLeave: false
    }, this.renderCurrentStep()));
  }
});

var _default = (0, _reactRedux.connect)(null, FormActions)(CompactBookingPage);

exports.default = _default;
module.exports = exports.default;